import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const AddDomains = () => {
  const { id } = useParams(); // Get publisher ID from URL
  const navigate = useNavigate();
  const [domain, setDomain] = useState("");
  const [name, setName] = useState(""); 
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/addNewSite`,
        {
          account_id: id, // Publisher ID
          name: name, // Domain name
          domain: domain,
          status: "0",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      console.log(response);
      
      if (response.status === 201) {
        setMessage("Domain added successfully!");
        setDomain(""); // Reset input field after successful submission

        // Redirect after 2 seconds
        setTimeout(() => {
          navigate("/publisher-list"); // Redirect to publisher list page
        }, 2000);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        console.error("Unauthorized! Token might be expired.");
        localStorage.removeItem("token");
        navigate("/");
      } else {
        console.error("Error fetching data:", error);
      }
      setMessage(
        error.response?.data?.message || "Failed to add domain. Try again!"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mainContainer">
    <div className="container mt-4">
      <h2>Add Domain</h2>
      {message && <div className="alert alert-info">{message}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Domain Name :</label>
          <input
            type="text"
            className="form-control"
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
            required
            placeholder="Enter domain name"
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Name :</label>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            placeholder="Enter name"
          />
        </div>
        <button type="submit" className="btn btn-success" disabled={loading}>
          {loading ? "Adding..." : "Add Domain"}
        </button>
        <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate(-1)}>
          Cancel
        </button>
      </form>
    </div>
    </section>
  );
};

export default AddDomains;
